(function () {
    'use strict';

    angular.module("imApp").factory("stockLocationCtrlService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1077,
                    parameters: parms || {}
                });
            },
            listControllers: function (parms) {
                return $ihttp.post({
                    method: 1078,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1079,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
